export enum PAYMENT_METHOD_IDS {
  BONUS_CARD = 'BONUS_CARD',
  GIFT_CERTIFICATE = 'GIFT_CERTIFICATE',
  BT_CREDIT_CARD = 'BT_CREDIT_CARD',
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PayPal',
  GOOGLE_PAY = 'GooglePay',
  APPLE_PAY = 'ApplePay',
  KLARNA = 'KLARNA_PAYMENTS',
  CLEARPAY = 'CLEARPAY'
}

export enum CARD_TYPES {
  AMERICAN_EXPRESS = 'amex',
  VISA = 'Visa',
  DISCOVER = 'Discover',
  MASTERCARD = 'MasterCard',
  PAYPAL = 'PayPal',
  GENERIC = 'Generic',
  CREDIT_CARD = 'Credit / Debit Card',
  BONUS_CARD = 'Bonus Card',
  GIFT_CERTIFICATE = 'Gift Certificate',
  GOOGLE_PAY = 'Google Pay',
  APPLE_PAY = 'Apple Pay',
  KLARNA = 'Klarna',
  CLEARPAY = 'Clearpay'
}
export type CARD_TYPES_CODE = `${CARD_TYPES}`

export const CARD_TYPES_NAMES = {
  [CARD_TYPES.AMERICAN_EXPRESS]: 'Amex',
  [CARD_TYPES.VISA]: 'Visa',
  [CARD_TYPES.DISCOVER]: 'Discover',
  [CARD_TYPES.MASTERCARD]: 'MasterCard',
} as const

export const CreditCardValidatorTypesMap = {
  mastercard: CARD_TYPES.MASTERCARD,
  'american-express': CARD_TYPES.AMERICAN_EXPRESS,
  visa: CARD_TYPES.VISA,
  discover: CARD_TYPES.DISCOVER,
}

export enum KLARNA_OSM_KEYS {
  CREDIT_PROMOTION = 'credit-promotion-badge',
  CREDIT_PROMOTION_AUTO = 'credit-promotion-auto-size',
  TOP_STRIP_PROMOTION = 'top-strip-promotion-badge',
  TOP_STRIP_PROMOTION_AUTO = 'top-strip-promotion-auto-size',
  FOOTER_PROMOTION = 'footer-promotion-auto-size',
  INFO_PAGE = 'info-page',
  SIDEBAR_PROMOTION = 'sidebar-promotion-auto-size',
  HOMEPAGE_PROMOTION_WIDE = 'homepage-promotion-wide',
  HOMEPAGE_PROMOTION_TALL = 'homepage-promotion-tall',
  HOMEPAGE_PROMOTION_BOX = 'homepage-promotion-box',
}

export enum KlarnaPaymentCategories {
  KLARNA = 'klarna'
}

export interface KlarnaPaymentMethodCategory {
  asset_urls: {
    descriptive: string
    standard: string
  },
  identifier: KlarnaPaymentCategories,
  name: string
}

export interface KlarnaSessionResponse {
  client_token: string
  payment_method_categories: KlarnaPaymentMethodCategory[]
  session_id: string
  errMessage?: string
  authorization_token?: string
}

export interface ClearpayCreateCheckoutResponse {
  token?: string
  message?: string
  errorCode?: string
}

export interface KlarnaLoadResponse {
  show_form: boolean
}

export interface KlarnaAuthorizeResponse {
  approved: boolean
}

export interface KlarnaAuthorizeResponse {
    show_form: boolean
    finalize_required: boolean
    authorization_token?: string
    client_token: string
}

export interface KlarnaSetupData {
  client_token?: string
  session_id?: string
  category?: KlarnaPaymentMethodCategory
  show_form?: boolean
  button_rendered?: boolean
  order_amount?: number
}

export interface ClearpaySetupData {
  token?: string
  button_rendered?: boolean
  order_amount?: number
  order_token?: string
  button_initialized?: boolean
}

export interface clearpayOnCompleteResponse {
  data: {
    orderToken: string
    status: string
  }
}

export const EmptyCardNumber = '****'

export const SupportedApplePayVersion = 3
export const applePayScript = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
export const klarnaScript = 'https://x.klarnacdn.net/kp/lib/v1/api.js'
export const clearpaySandboxScript = 'https://portal.sandbox.afterpay.com/afterpay.js'
export const clearpayScript = 'https://portal.afterpay.com/afterpay.js'
export const klarnaOSMScript = 'https://js.klarna.com/web-sdk/v1/klarna.js'